"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionExistsModal = void 0;

var react_1 = __importStar(require("react"));

var react_modal_1 = __importDefault(require("react-modal"));

var theme_ui_1 = require("theme-ui");

var billing_1 = require("../billing");

var react_2 = require("../common/react");

var SubscriptionExistsModal = function SubscriptionExistsModal() {
  var _react_2$useLocalStat = react_2.useLocalState("lastSubscriptionState", true),
      _react_2$useLocalStat2 = _slicedToArray(_react_2$useLocalStat, 2),
      modalOpen = _react_2$useLocalStat2[0],
      setModalOpen = _react_2$useLocalStat2[1];

  react_1.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var hasSubscription;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return billing_1.currentUserHasValidSubscription();

            case 2:
              hasSubscription = _context.sent;
              setModalOpen(!hasSubscription);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  });
  return react_1.default.createElement(react_modal_1.default, {
    isOpen: modalOpen,
    shouldCloseOnEsc: false,
    ariaHideApp: false,
    parentSelector: function parentSelector() {
      return document.getElementById("subscription-modal-parent");
    },
    style: {
      overlay: {
        display: "flex"
      },
      content: {
        margin: "auto",
        position: "unset"
      }
    }
  }, react_1.default.createElement(theme_ui_1.Box, null, react_1.default.createElement(theme_ui_1.Heading, {
    as: "h2"
  }, "No subscription found. Please go to ", react_1.default.createElement(theme_ui_1.Link, {
    href: "https://roam.garden/app",
    target: "_blank"
  }, "Roam Garden"), " to set one up")));
};

exports.SubscriptionExistsModal = SubscriptionExistsModal;